import { createDiaryFunctions } from '../factory'
import {
    IntermediaryDiary,
    IntermediaryDiaryDeleteResponse,
    IntermediaryDiaryDetailResponse,
    IntermediaryDiaryListCriteria,
    IntermediaryDiaryListResponse,
    IntermediaryDiaryUpdatePayload,
} from './types'

const intermediaryDiaryFunctions = createDiaryFunctions<
    IntermediaryDiary,
    IntermediaryDiaryUpdatePayload,
    IntermediaryDiaryListResponse,
    IntermediaryDiaryDetailResponse,
    IntermediaryDiaryDeleteResponse,
    IntermediaryDiaryListCriteria
>('v1/intermediary-diary')

export const getIntermediaryDiaries = intermediaryDiaryFunctions.getDiaries
export const getIntermediaryDiary = intermediaryDiaryFunctions.getDiary
export const updateIntermediaryDiary = intermediaryDiaryFunctions.updateDiary
export const deleteIntermediaryDiary = intermediaryDiaryFunctions.deleteDiary
export const downloadIntermediaryDiaryPdf = intermediaryDiaryFunctions.downloadDiaryPdf
